import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TemplatesService } from '../templates.service';
import { TemplateDto } from '../templates.model';
import { EntriesService } from '../../entries/entries.service';
import { Observable, forkJoin, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class TemplateDetailsResolver {
  public hasPermissions: boolean = false;

  constructor(private templatesService: TemplatesService, private entriesService: EntriesService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return forkJoin({
      templateQuestionTypeList: this.entriesService.getAllQuestionTypes(),
      template: route.params['id'] ? this.templatesService.getTemplate(route.params['id']) : of(null),
    });
  }
}
